var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 113 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M88.8193 29.8843L84.9928 34.3422C88.535 38.2265 93.5615 40 98.8193 40C106.246 40 112.988 35.3687 112.988 28.3422C112.988 15.2 91.6193 18.5735 91.6193 10.5157C91.6193 7.25783 94.8193 5.71566 98.8771 5.71566C102.251 5.71566 105.561 7.25783 107.851 9.03133L110.877 4.34699C107.451 1.54699 103.161 0.0048181 98.7663 0.0048181C92.3663 0.0048181 85.7928 3.77349 85.7928 10.6313C85.7928 23.7735 107.161 20.4578 107.161 28.347C107.161 32.4578 102.993 34.2892 98.8193 34.2892C95.0458 34.2843 91.0458 32.1108 88.8193 29.8843Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.547 0C70.6313 0 79.547 8.96868 79.547 20C79.547 31.0313 70.6313 40 59.547 40C48.5205 40 39.547 31.0265 39.547 20C39.547 8.97349 48.5156 0 59.547 0ZM59.6 34.2843C67.3687 34.2843 73.7156 27.6578 73.7156 20C73.7156 12.2843 67.3735 5.71566 59.6 5.71566C51.8265 5.71566 45.3735 12.2892 45.3735 20C45.3735 27.6578 51.8313 34.2843 59.6 34.2843Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1422 6.68434C31.4843 2.51566 26.1157 0 20 0C8.91566 0 0 8.85783 0 20C0 31.1422 8.91566 40 20 40C26.2265 40 31.6578 37.3735 35.3157 33.1422L30.9157 29.3735C28.3422 32.4 24.4578 34.2892 20 34.2892C12.2843 34.2892 5.83133 27.7157 5.83133 20.0048C5.83133 12.294 12.2892 5.72048 20 5.72048C24.4578 5.72048 28.2265 7.66265 30.9157 10.694L35.1422 6.68434Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCos);
export default __webpack_public_path__ + "static/media/COS.a0bf07e6a04e99833d86f63780f81fa9.svg";
export { ForwardRef as ReactComponent };